import * as React from 'react';
import { Checkmark } from '../../common';
import { Style, StyleTag, StyleText } from '../../../models';
import './PVAStyleBreakdown.css';
import { computed } from 'mobx';

interface PVAStyleBreakdownProps {
    style: Style;
    brief: string;
    content: string;
    name: string;
    showSecondaryStyle: boolean;
    noPadding?: boolean;
    hideBrief?: boolean;
}

export class PVAStyleBreakdown extends React.Component<PVAStyleBreakdownProps, { modalVisible: boolean, secondaryStyleModalVisible: boolean }> {
    constructor(props: PVAStyleBreakdownProps) {
        super(props);

        this.state = {
            modalVisible: false,
            secondaryStyleModalVisible: false
        };
    }

    @computed get showSecondaryStyle() {
        if (this.props.showSecondaryStyle === null) {
            return false;
        }
        return this.props.showSecondaryStyle;
    }

    toggleModal() {
        this.setState({ modalVisible: !this.state.modalVisible });
    }

    render() {
        const subCoreStyles = (this.props.style.styleTexts || []).filter((styleText: StyleText) => {
            return styleText.styleTextType === 'subCore';
        });

        return (
            <div className={`breakdown-outer-container ${this.props.noPadding ? 'no-padding' : ''}`}>
                {!this.props.hideBrief && (
                    <div className="breakdown-intro-row">
                        <div className="breakdown-brief font-second-level" dangerouslySetInnerHTML={{ __html: this.props.brief}} />
                    </div>
                )}
                <div className="breakdown-tags-container">
                    {/*{!this.props.noPadding && <span className="traits font-heading">Traits:</span>}*/}
                    <div className="breakdown-tags-row font-heading">
                        { 
                            this.props.style.styleTags && this.props.style.styleTags.length > 0 && this.props.style.styleTags.map((styleTag: StyleTag, ind: number) => {
                                const styleClass = this.props.style && this.props.style.name ? `style-${this.props.style.name.toLowerCase()}` : '';
                                return <React.Fragment key={`st-${ind}`}>
                                    <div className="breakdown-tag-icon-and-text">
                                        <Checkmark className={`breakdown-intro-tag-icon ${styleClass}`}/>
                                        <div className="breakdown-intro-tag">{styleTag.value}</div>
                                    </div>
                                    {/*{ind < this.props.style.styleTags.length - 1 && <div className="tag-separator"></div>}*/}
                                </React.Fragment>;
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVAStyleBreakdown.tsx